// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ItemTemplatesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemTemplateFilter>;
}>;


export type ItemTemplatesQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', displayName: string, version: string, isVersioned: boolean, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], stage: Types.Stage, status: Types.ItemTemplateStatus, description?: string | null | undefined, id: string, name: string, statusDetail: { __typename?: 'ItemTemplateStatusDetail', name: string, code: Types.ItemTemplateStatus }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string } | null | undefined }> };

export type SettingsItemTemplateFragment = { __typename?: 'ItemTemplate', displayName: string, version: string, isVersioned: boolean, createdAt: Types.Scalars['DateTime']['input'], updatedAt: Types.Scalars['DateTime']['input'], stage: Types.Stage, status: Types.ItemTemplateStatus, description?: string | null | undefined, id: string, name: string, statusDetail: { __typename?: 'ItemTemplateStatusDetail', name: string, code: Types.ItemTemplateStatus }, development?: { __typename?: 'Development', id: string, name: string } | null | undefined, readyPlan?: { __typename?: 'ReadyPlan', id: string } | null | undefined };

export const SettingsItemTemplateFragmentDoc = gql`
    fragment SettingsItemTemplate on ItemTemplate {
  ...Named
  displayName
  version
  isVersioned
  createdAt
  updatedAt
  stage
  status
  statusDetail {
    name
    code
  }
  description
  development {
    ...Named
  }
  readyPlan {
    id
  }
}
    ${NamedFragmentDoc}`;
export const ItemTemplatesDocument = gql`
    query ItemTemplates($filter: ItemTemplateFilter) {
  itemTemplates(filter: $filter) {
    ...SettingsItemTemplate
  }
}
    ${SettingsItemTemplateFragmentDoc}`;

/**
 * __useItemTemplatesQuery__
 *
 * To run a query within a React component, call `useItemTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useItemTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ItemTemplatesQuery, ItemTemplatesQueryVariables>(ItemTemplatesDocument, options);
      }
export function useItemTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ItemTemplatesQuery, ItemTemplatesQueryVariables>(ItemTemplatesDocument, options);
        }
// @ts-ignore
export function useItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplatesQuery, ItemTemplatesQueryVariables>;
export function useItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ItemTemplatesQuery | undefined, ItemTemplatesQueryVariables>;
export function useItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ItemTemplatesQuery, ItemTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ItemTemplatesQuery, ItemTemplatesQueryVariables>(ItemTemplatesDocument, options);
        }
export type ItemTemplatesQueryHookResult = ReturnType<typeof useItemTemplatesQuery>;
export type ItemTemplatesLazyQueryHookResult = ReturnType<typeof useItemTemplatesLazyQuery>;
export type ItemTemplatesSuspenseQueryHookResult = ReturnType<typeof useItemTemplatesSuspenseQuery>;
export type ItemTemplatesQueryResult = ApolloReactCommon.QueryResult<ItemTemplatesQuery, ItemTemplatesQueryVariables>;